import { lazy, useMemo } from "react";
import { LoadingSpinner } from "./reusable/LoadingSpinner";
import { useQuoteController } from "../contexts/QuoteControllerContext";
import { InstallationSwitcher } from "./InstallationSwitcher";
import QuoterError from "./reusable/QuoteError";
import { LLMContextProvider } from "../contexts/LLMContext";
import { ProgressBarContextProvider } from "../contexts/ProgressBarContext";
import '../util/dateUtils';

const TapolyV2 = lazy(() => import("./installations/TapolyV2"));
const TapolyAI = lazy(() => import("./installations/TapolyAI"));
const TapolyAIDemo = lazy(() => import("./installations/TapolyAIDemo"));

const Home = () => {
    const { isLoading, branding, quoteInProgress, quoteErrors } = useQuoteController();

    const contentToRender = useMemo(() => {
        //For broker quotes (via admin2) we always show the "old" flow
        if (quoteInProgress && quoteInProgress.isBrokerQuote)
            return <TapolyV2 />

        switch (branding?.installation) {
            case "Tapoly":
                return <TapolyV2 />
            case "Tapoly-AI":
                return <TapolyAI />
            case "Tapoly-AI-Demo":
                return <TapolyAIDemo />
            default:
                return null;
        }
    }, [quoteInProgress, branding?.installation]);

    if (quoteErrors && quoteErrors.length > 0)
        return <QuoterError errors={quoteErrors} />;

    return (
        <div>
            {/*<InstallationSwitcher />*/}
            <LoadingSpinner show={isLoading} />

            <LLMContextProvider>
                <ProgressBarContextProvider>
                    {contentToRender}
                </ProgressBarContextProvider>
            </LLMContextProvider>
        </div>
    )
};

export default Home;
